export LoginPage from './user/Login'
export RegisterPage from './user/Register'
export WeChatPage from './user/WeChat';
export ForgetPage from './user/Forget'
export DefaultPage from './master/Default'
export TestPage from './master/Test'
export ErrorNotFoundPage from './errors/NotFound'



// WEBPACK FOOTER //
// ./src/common/containers/index.jsx